import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import { ScrollView } from "devextreme-react";
import PaginaToolbar from "../../../components/PaginaToolbar";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import Toolbar, { Item } from "devextreme-react/toolbar";
import uiInfo from "../../../ui-info";
import { getUsuarioNfseCpbsDs } from "../../../DataSources";
import apiAxios from "../../../api-axios";
import ShowError from "../../../AppServices";
import UserInfo from "../../../UserInfo";
import { mascaraCPFCNPJ } from "../../../utils/documentsUtils";
import notify from "devextreme/ui/notify";

const popupControlValues = {
  UPDATEEMAIL: { dataField: "email", label: "Novo Email" },
  UPDATEPASSWORD: { dataField: "novaSenha", label: "Nova Senha" },
  SHOWUSER: {},
  "": {},
};

export default class UsuariosNfseBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.state = {
      inscricao: localStorage.getItem("inscricao_cpbs"),
      cpbsId: localStorage.getItem("id_cpbs"),
      usuariosCpbs: [],
      showPopup: false,
      popupControl: "",
    };
    this.loadUsers = this.loadUsers.bind(this);
    this.usuariosNfseDs = getUsuarioNfseCpbsDs();
    this.updateUser = this.updateUser.bind(this);
    this.resendAccess = this.resendAccess.bind(this);
    this.renderPopupContent = this.renderPopupContent.bind(this);
    this.renderUserData = this.renderUserData.bind(this);
  }

  async componentDidMount() {
    if (this.props.match.params.id) {
      await this.loadUsers();
    }
  }

  async loadUsers() {
    try {
      const response = await apiAxios.get(
        `/cpbs/usuario_cpbs/${UserInfo.getPrefeitura()}/${
          this.props.match.params.id
        }`
      );
      if (response.status === 200) {
        this.setState({ usuariosCpbs: response.data, showPopup: false });
      }
    } catch (error) {
      ShowError(error);
    }
  }

  async updatePassword(requestBody) {
    try {
      const response = await apiAxios.post(
        `/cpbs/usuario_cpbs/atualizar_senha`,
        { ...requestBody, novaSenha: this.state.novaSenha }
      );
      return response;
    } catch (error) {
      ShowError(error);
    }
  }

  async updateEmail(requestBody) {
    try {
      const response = await apiAxios.post(
        `/cpbs/usuario_cpbs/atualizar_email`,
        { ...requestBody, email: this.state.email }
      );
      return response;
    } catch (error) {
      ShowError(error);
    }
  }

  async resendAccess(user) {
    if (user) {
      try {
        const response = await apiAxios.post(
          `/cpbs/usuario_cpbs/enviar_acesso/${user.cpbsId}/${user.prefeituraId}/${user.id}`
        );
        if (response && response.status === 204) {
          notify("Acesso enviado com sucesso!", "success");
        }
      } catch (error) {
        ShowError(error);
      }
    }
  }

  renderPopupContent(popupType) {
    const dataField = popupControlValues[popupType].dataField;
    const label = popupControlValues[popupType].label;
    return (
      <Form formData={this.state} colCount={1} labelLocation={"top"}>
        <SimpleItem dataField={dataField} colSpan={1}>
          <Label text={label} />
        </SimpleItem>
      </Form>
    );
  }

  renderUserData() {
    return (
      <Form
        formData={this.state.userData}
        colCount={2}
        labelLocation={"top"}
        readOnly={true}
      >
        <SimpleItem dataField={"cpfCnpj"} colSpan={1}>
          <Label text={"Documento"} />
        </SimpleItem>
        <SimpleItem dataField={"nome"} colSpan={1}>
          <Label text={"Nome"} />
        </SimpleItem>
        <SimpleItem dataField={"email"} colSpan={1}>
          <Label text={"E-mail"} />
        </SimpleItem>
        <SimpleItem dataField={"senha"} colSpan={1}>
          <Label text={"Senha"} />
        </SimpleItem>
      </Form>
    );
  }

  async updateUser(user, requestType) {
    console.log(this.state);
    if (user) {
      const requestBody = {
        cpbsId: user.cpbsId,
        prefeituraId: user.prefeituraId,
        usuarioId: user.id,
      };
      let response;
      if (requestType === "UPDATEEMAIL")
        response = await this.updateEmail(requestBody);
      else if (requestType === "UPDATEPASSWORD")
        response = await this.updatePassword(requestBody);

      if (response && response.status === 200) {
        notify("Usuário atualizado com sucesso!", "success");
        this.loadUsers();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Toolbar>
            <Item
              location="left"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Voltar",
                icon: "arrowleft",
                onClick: (e) => {
                  console.log("evento socios box", e);
                  this.props.history.push("/cpbs/editar/" + this.state.cpbsId);
                },
              }}
            />
          </Toolbar>
          <Form formData={this.state} colCount={3}>
            <GroupItem caption="DADOS CPBS" colSpan={3} colCount={5}>
              <SimpleItem
                dataField={"inscricao"}
                colSpan={1}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Inscrição" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <br />
          <PaginaToolbar
            titulo="Usuários da NFS-e"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.state.usuariosCpbs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
            >
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    hint: "Alterar senha",
                    icon: "key",
                    onClick: ({ row }) =>
                      this.setState({
                        showPopup: true,
                        popupControl: "UPDATEPASSWORD",
                        userData: row.data,
                      }),
                  },
                  {
                    hint: "Alterar e-mail",
                    icon: "email",
                    onClick: ({ row }) =>
                      this.setState({
                        showPopup: true,
                        popupControl: "UPDATEEMAIL",
                        userData: row.data,
                      }),
                  },
                  {
                    hint: "Reenviar acesso",
                    icon: "export",
                    onClick: ({ row }) => this.resendAccess(row.data),
                  },
                  {
                    hint: "Ver usuário",
                    icon: "card",
                    onClick: ({ row }) =>
                      this.setState({
                        showPopup: true,
                        popupControl: "SHOWUSER",
                        userData: row.data,
                      }),
                  },
                ]}
              />
              <Column dataField={"id"} caption={"Código Acesso"} width={80} />
              <Column dataField={"nome"} caption={"Nome"} />
              <Column dataField={"email"} caption={"E-mail"} />
              <Column dataField={"login"} caption={"Login"} />
              <Column
                dataField={"senha"}
                caption={"Senha"}
                width={155}
                cellRender={({ row }) => {
                  return (
                    <div className="hide-password">
                      <input
                        id={`input-password${row.data.id}`}
                        defaultValue="*********"
                      />
                      <button
                        className="dx-icon-find"
                        title="Mostrar senha"
                        onClick={() => {
                          if (
                            document.getElementById(
                              `input-password${row.data.id}`
                            ).value === "*********"
                          ) {
                            document.getElementById(
                              `input-password${row.data.id}`
                            ).value = row.data.senha;
                          } else {
                            document.getElementById(
                              `input-password${row.data.id}`
                            ).value = "*********";
                          }
                        }}
                      />
                    </div>
                  );
                }}
              />
              <Column
                dataField={"documento"}
                caption={"Documento"}
                cellRender={({ row }) => {
                  return <div>{mascaraCPFCNPJ(row.data.cpfCnpj)} </div>;
                }}
              />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
          <Popup
            visible={this.state.showPopup}
            onHiding={() => this.setState({ showPopup: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={this.state.popupControl === "SHOWUSER" ? "800px" : "400px"}
            height={this.state.popupControl === "SHOWUSER" ? "500px" : "250px"}
            title={
              this.state.popupControl === "SHOWUSER"
                ? "Dados do Usuário"
                : "Atualizar usuário"
            }
          >
            <ScrollView showScrollbar={"onScroll"}>
              {this.state.popupControl === "SHOWUSER"
                ? this.renderUserData()
                : this.renderPopupContent(this.state.popupControl)}
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ showPopup: false }),
              }}
            />
            {this.state.popupControl === "SHOWUSER" ? undefined : (
              <ToolbarItem
                toolbar={"bottom"}
                widget="dxButton"
                location="center"
                options={{
                  text: "Enviar",
                  type: "success",
                  width: 150,
                  onClick: () =>
                    this.updateUser(
                      this.state.userData,
                      this.state.popupControl
                    ),
                }}
              />
            )}
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    this.props.history.push({
      pathname: `/cpbs_socios/${this.state.cpbsId}/novo`,
      dadosCpbs: {
        inscricao: this.state.inscricao,
        contribuinteNome: this.state.contribuinteNome,
      },
    });
  }
}
